<template>
  <a-spin :spinning="loading">
    <div class="spin-content">
      <a-tabs defaultActiveKey="1">
        <a-tab-pane tab="FILTROS" key="1">
          <a-card>
            <a-row :gutter="16">
              <a-col v-bind="responsive.cTurnoCfg" :md="{span: 8}">
                <a-form :form="formCargar" @submit="cargarEmpleados">
                  <g-dropdown endpoint="hierarchy_lookup"
                              :decorator="['grupo', decoradores.valor_requerido]"
                              :formItemConfig="{label:'Grupo', 'label-col': {span: 4}, 'wrapper-col': {span: 20}}"
                              :params="grupoParams"
                              :selectedObj.sync="grupoSeleccionado"
                              @change="grupoCambiado"></g-dropdown>

                  <g-dropdown endpoint="hierarchy_lookup"
                              :decorator="['puesto', decoradores.valor_requerido]"
                              :formItemConfig="{label:'Puesto', 'label-col': {span: 4}, 'wrapper-col': {span: 20}}"
                              :selectedObj.sync="puestoSeleccionado"
                              :params="puestoParams"></g-dropdown>

                  <g-dropdown
                    v-if="visible_id_h_att3"
                    endpoint="hierarchy_lookup"
                    :decorator="['id_h_att3', {rules: [{required: false, message: 'Valor requerido'}]}]"
                    :formItemConfig="{label: $t('ID_H_ATT3'), 'label-col': {span: 4}, 'wrapper-col': {span: 20}}"
                    :params="id_h_att3">
                  </g-dropdown>


                  <a-form-item :wrapper-col="{sm: {span: 18, offset: 4}, md: {span: 24, offset: 4}}"
                               style="margin-bottom: 0;">
                    <a-button type="primary" html-type="submit">Cargar</a-button>
                    <a-divider type="vertical"/>
                    <a-badge :count="filasSeleccionadas.length"
                             :number-style="{
                                backgroundColor: '#ff4d4f',
                             }"
                             v-if="filasSeleccionadas.length > 0">
                      <a-button type="danger" html-type="button" @click="eliminarTurnos">Eliminar turnos</a-button>
                    </a-badge>
                  </a-form-item>
                </a-form>
              </a-col>
              <a-col v-bind="responsive.cTurnoCfg" :md="{span: 0}">
                <a-divider/>
              </a-col>
              <a-col v-bind="responsive.cTurnoCfg" :md="{span: 16}">
                <a-row :gutter="8">
                  <a-form :form="formAplicar" @submit="aplicarSecuencia">
                    <a-col v-bind="responsive.cTurnoCfg" :md="{span: 8}">
                      <g-dropdown endpoint="shifts_type"
                                  :decorator="['turno', decoradores.valor_requerido]"
                                  :formItemConfig="{label:'Cambiar Turno', 'label-col': {sm: {span: 6}, md: {span: 12}}, 'wrapper-col':  {sm: {span: 18}, md: {span: 12}}}"
                                  :selectedObj.sync="turnoSeleccionado"></g-dropdown>
                    </a-col>
                    <a-col v-bind="responsive.cTurnoCfg" :md="{span: 8}">
                      <g-select :options="listas.iniciales"
                                :decorator="['inicial', decoradores.valor_requerido]"
                                :selectedObj.sync="inicial"
                                :formItemConfig="{label:'Inicial', 'label-col':{sm: {span: 6}, md: {span: 8}}, 'wrapper-col': {sm: {span: 18}, md: {span: 16}}}"></g-select>
                    </a-col>
                    <a-col v-bind="responsive.cTurnoCfg" :md="{span: 8}">
                      <a-form-item
                        :wrapper-col="{sm: {span: 18, offset: 6}, md: {span: 24, offset: 0}}">
                        <a-input v-model="secuencia" disabled/>
                      </a-form-item>
                    </a-col>
                    <a-col v-bind="responsive.cTurnoCfg" :md="{span: 12}">
                      <g-dropdown endpoint="hierarchy_lookup"
                                  :formItemConfig="{label:'Periodo', 'label-col':{sm: {span: 6}, md: {span: 12}}, 'wrapper-col': {sm: {span: 18}, md: {span: 12}}}"
                                  :decorator="['periodo', decoradores.valor_requerido]"
                                  :params="{h_lookup_type: 'PERIODOS_LIQUIDACION', use_code: true}">
                      </g-dropdown>
                    </a-col>
                    <a-col v-bind="responsive.cTurnoCfg" :md="{span: 8}">
                      <a-form-item style="margin-bottom: 0;"
                                   :label-col="{sm: {span: 6}, md: {span: 8}}"
                                   :wrapper-col="{sm: {span: 18, offset: 6}, md: {span: 24, offset: 8}}">
                        <a-button type="primary" html-type="submit">Aplicar</a-button>
                      </a-form-item>
                    </a-col>
                  </a-form>
                </a-row>
              </a-col>
            </a-row>
          </a-card>
          &nbsp;
          <a-table size="small" :columns="columns" :dataSource="empleados" :pagination="false"
                   rowKey="id_emp" :scroll="{x: 2000, y: 500}"
                   :rowSelection="{selectedRowKeys: filasSeleccionadas,  onChange: filaSeleccionada}">
            <sm-input :slot="'itemRender'+(columna-1)"
                      slot-scope="text, record, fila"
                      v-model="empleados[fila].config[columna-1].value"
                      v-for="columna in 31"
                      :read-only="empleados[fila].config[columna-1].readOnly"
                      :editable="empleados[fila].config[columna-1].editable"
                      :loading="empleados[fila].config[columna-1].loading"
                      :valoresPermitidos="valoresPermitidos"
                      :festivo="festivos.includes(columna)"
                      :domingo="domingos.includes(columna)"
                      :notas="empleados[fila].config[columna-1].notas"
                      :color="empleados[fila].config[columna-1].color"
                      @input="(value) => { columnaCambiada(empleados[fila], fila, columna-1, value) }"
                      @delete="() => {eliminarTurno(empleados[fila], fila, columna-1)}"
            ></sm-input>
            <span slot="nombreRenderer" slot-scope="text, record, index">
                  <a-popover v-if="parseInt(record.reemplazo) > 0">
                    <template slot="content">
                      {{record.nombre_reemplazado}}
                    </template>
                    <a-tag color="red">R</a-tag>
                   </a-popover>
                  {{text}}
                </span>
          </a-table>
        </a-tab-pane>
        <div slot="tabBarExtraContent">
          <a-button @click="() => {modalExtrashiftsVisible = true}" type="primary">
            Turnos extra
          </a-button>
          <a-month-picker v-model="selectedMonth" placeholder="Seleccione un mes" @change="mesCambiado"
                          :disabled-date="disabledDate"/>
        </div>
      </a-tabs>
      <modal-extra-shifts :visible="modalExtrashiftsVisible" :month="selectedMonth"
                          @ok="() => {modalExtrashiftsVisible = false}"></modal-extra-shifts>
    </div>
  </a-spin>
</template>
<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'
  import DateUtils from '@/util/DateUtils'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'

  export default {
    data () {
      return {
        responsive: {
          cTurnoCfg: {
            xs: {span: 24}
          }
        },
        selectedMonth: moment(),
        grupoSeleccionado: {},
        puestoSeleccionado: {},
        turnoSeleccionado: {},
        listas: {
          grupos: [],
          puestos: [],
          iniciales: []
        },
        filasSeleccionadas: [],
        formCargar: this.$form.createForm(this, {
          name: 'frmCargar'
        }),
        formAplicar: this.$form.createForm(this, {
          name: 'frmAplicar'
        }),
        decoradores: {
          valor_requerido: {rules: [{required: true, message: 'Valor requerido'}]}
        },
        turno: null,
        inicial: null,
        numero: 6,
        columns: [],
        empleados: [],
        loading: false,
        valoresPermitidos: [],
        modalExtrashiftsVisible: false,
        festivos: [],
        domingos: [],
        id_h_att3: {
          h_lookup_type: 'ID_H_ATT3'
        },
        visible_id_h_att3: this.$getConfigValue('MOSTRAR_ID_H_ATT3_TURNO', 'NO') === 'SI',
        can_view_groups: this.$getConfigValue('CAN_VIEW_GROUPS', 'NO') === 'SI'
      }
    },
    async created () {
      this.valoresPermitidos = await new Promise(resolve => {
        HttpUtil.getStaticInstance().get('ct/opciones_disponibles').then(response => {
          resolve(response.data)
        }).catch(() => {
          Mensajes.error('Error', 'No fue posible cargar las opciones permitidas.')
          resolve([])
        })
      })
    },
    mounted () {
      this.http = new HttpUtil()
      this.initDataTable()
    },
    methods: {
      mesCambiado (e) {
        this.initDataTable()
      },
      cargarEmpleados (e) {
        e.preventDefault()
        if (this.loading) {
          return
        }
        this.formCargar.validateFields((err, values) => {
          if (!err) {
            this.loading = true
            this.empleados.splice(0, this.empleados.length)

            this.http.getInstance().get('ct/consultar_empleados', {
              params: {
                periodo: DateUtils.forBackEnd(this.selectedMonth),
                grupo: values.grupo,
                puesto: values.puesto,
                id_h_att3: values.id_h_att3
              }
            }).then((response) => {
              this.empleados.splice(0, this.empleados.length)
              let empleados = response.data.empleados
              this.festivos = response.data.festivos
              this.domingos = response.data.domingos
              empleados.map((empleado) => {
                this.empleados.push(empleado)
              })
            }).catch(() => {
              Mensajes.error('Error', 'No fue posible cargar los empleados, contacte a mesa de ayuda.')
            }).then(() => {
              this.loading = false
            })
          }
        })
      },
      aplicarSecuencia (e) {
        e.preventDefault()
        this.formAplicar.validateFields((err, values) => {
          if (!err) {
            this.filasSeleccionadas.map(key => {
              let empleado = this.buscaEmpelado(key)
              if (empleado !== null) {
                let cambiado = false
                /* debo generar la secuencia iniciando con values.inicial */
                let consecutivoSecuencia = values.inicial

                /* Segun el periodo seleccionado debes iniciar en 0 o en 15 */
                let diaInicio = values.periodo !== '4' ? 0 : 15
                let diaFin = values.periodo === '2' ? 15 : empleado.config.length

                for (let dialDelMes = diaInicio; dialDelMes < diaFin; dialDelMes++) {
                  /* por cada dia del mes debo asihnar una secuencia */
                  let config = empleado.config[dialDelMes]
                  if (config.editable) {
                    config.value = this.listas.iniciales[consecutivoSecuencia].text
                    cambiado = true
                  }
                  consecutivoSecuencia++
                  if (consecutivoSecuencia === this.listas.iniciales.length) {
                    consecutivoSecuencia = 0
                  }
                }
                if (cambiado) {
                  this.actualizarEmpleado(empleado)
                } else {
                  Mensajes.warning('Advertencia', 'No es posible actualizar el empleado ' + empleado.nombre)
                }
              }
            })
          }
        })
      },
      columnaCambiada (empleado, fila, columna, value) {
        if (!empleado.config[columna].editable) {
          return
        }
        empleado.config[columna].readOnly = true
        empleado.config[columna].loading = true

        let fechaRequest = moment(this.selectedMonth)
        fechaRequest.date(columna + 1)

        this.http.getInstance().post('ct/actualizar_turno', {
          fecha: DateUtils.forBackEnd(fechaRequest),
          id_emp: empleado.id_emp,
          id_shift: value,
          grupo: this.grupoSeleccionado.value,
          puesto: this.puestoSeleccionado.value
        })
          .then((response) => {
            empleado.config[columna].readOnly = false
            empleado.config[columna].loading = false
          })
          .catch((error) => {
            Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible actualizar la marcación, contacte a mesa de ayuda.'))
          })
          .then(() => {
            empleado.config[columna].readOnly = false
            empleado.config[columna].loading = false
          })
      },
      actualizarEmpleado (empleado) {
        let setup = []
        let fechaRequest = moment(this.selectedMonth)
        let dia = 1
        empleado.config.map(config => {
          if (config.editable && !JsUtils.isEmpty(config.value)) {
            config.readOnly = true
            config.loading = true
            fechaRequest.date(dia++)
            setup.push({
              id_shift: config.value,
              fecha: DateUtils.forBackEnd(fechaRequest)
            })
          } else {
            dia++
          }
        })

        this.http.getInstance().post('ct/actualizar_turno_masivo', {
          id_emp: empleado.id_emp,
          setup: setup,
          grupo: this.grupoSeleccionado.value,
          puesto: this.puestoSeleccionado.value
        })
          .then((response) => {
            empleado.config.map(config => {
              if (config.editable) {
                config.readOnly = false
                config.loading = false
              }
            })
          })
          .catch((error) => {
            Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible actualizar la marcación, contacte a mesa de ayuda.'))
          })
          .then(() => {
            empleado.config.map(config => {
              if (config.editable) {
                config.readOnly = false
                config.loading = false
              }
            })
          })
      },
      eliminarTurnos (e) {
        e.preventDefault()
        if (this.loading) {
          return
        }

        this.loading = true
        let request = {
          fecha: DateUtils.forBackEnd(moment(this.selectedMonth)),
          empleados: this.filasSeleccionadas
        }

        this.http.getInstance().post('ct/eliminar_turnos', request)
          .then((response) => {
            this.loading = false
            this.cargarEmpleados(e)
            this.filasSeleccionadas = []
          })
          .catch(() => {
            Mensajes.error('Error', 'No fue posible eliminar los turnos.')
            this.loading = false
          })
      },
      initDataTable () {
        this.columns.splice(0, this.columns.length)
        let maxDay = this.getUltimoDiaDelMes()
        this.columns.push({
          title: 'Empleado',
          dataIndex: 'nombre',
          fixed: 'left',
          width: 340,
          scopedSlots: {customRender: 'nombreRenderer'}
        })
        for (let i = 1; i <= maxDay; i++) {
          this.columns.push({
            title: (i < 10 ? '0' + i : i) + ' ' + this.getDayOfWeek(i),
            dataIndex: 'config[' + (i - 1) + ']',
            scopedSlots: {customRender: 'itemRender' + (i - 1)},
            width: 70
          })
        }
      },
      filaSeleccionada (selectedRowKeys) {
        this.filasSeleccionadas = selectedRowKeys
      },
      buscaEmpelado (key) {
        for (let i = 0; i < this.empleados.length; i++) {
          if (this.empleados[i].id_emp === key) {
            return this.empleados[i]
          }
        }
        return null
      },
      getUltimoDiaDelMes () {
        return this.selectedMonth.endOf('month').date()
      },
      getDayOfWeek (day) {
        return moment(this.selectedMonth).date(day).format('ddd')
      },
      disabledDate (current) {
        return current &&
          (
            current.year() > moment().year()
          )
      },
      grupoCambiado () {
        this.formCargar.setFieldsValue({
          puesto: undefined
        })
      },
      eliminarTurno (empleado, fila, columna) {
        if (!empleado.config[columna].editable) {
          return
        }

        this.$confirm({
          title: 'Confirmación',
          content: '¿Está seguro que desea continuar?',
          okText: 'Si',
          okType: 'danger',
          cancelText: 'No',
          onOk: () => {
            return new Promise((resolve, reject) => {
              empleado.config[columna].readOnly = true
              empleado.config[columna].loading = true

              let fechaRequest = moment(this.selectedMonth)
              fechaRequest.date(columna + 1)

              this.http.getInstance().post('ct/eliminar_turno', {
                fecha: DateUtils.forBackEnd(fechaRequest),
                id_emp: empleado.id_emp,
                grupo: this.grupoSeleccionado.value,
                puesto: this.puestoSeleccionado.value
              })
                .then((response) => {
                  empleado.config[columna].readOnly = false
                  empleado.config[columna].loading = false
                  empleado.config[columna].value = ''
                  Mensajes.success('Correcto', 'Registro eliminado exitosamente.')
                  resolve()
                })
                .catch((error) => {
                  let errorMessage = this.$getErrorMessage(error, 'No fue posible eliminar la marcación, contacte a mesa de ayuda.')
                  Mensajes.error('Error', errorMessage)
                  reject(errorMessage)
                })
                .then(() => {
                  empleado.config[columna].readOnly = false
                  empleado.config[columna].loading = false
                })
            })
          },
          onCancel () {}
        })
      }
    },
    watch: {
      turnoSeleccionado () {
        this.listas.iniciales.splice(0, this.listas.iniciales.length)
        this.formAplicar.setFieldsValue({
          inicial: undefined
        })
        if (!JsUtils.isEmpty(this.turnoSeleccionado)) {
          this.turnoSeleccionado.shifts_master.map((secuencia, index) => {
            this.listas.iniciales.push({
              value: index, text: secuencia.id_shift
            })
          })
        }
      }
    },
    computed: {
      secuencia () {
        if (JsUtils.isEmpty(this.turnoSeleccionado)) {
          return ''
        }
        let concat = ''
        this.turnoSeleccionado.shifts_master.map((secuencia) => {
          concat += secuencia.id_shift + '|'
        })
        return (concat + '|').replace('||', '')
      },
      grupoParams () {
        // por solicitud de KR se cambia grupo_turno por id_h_att1 15/04/2020
        return {h_lookup_type: 'ID_H_ATT1', custom_handler: 'grupo_lleno', can_view_groups: this.can_view_groups}
      },
      puestoParams () {
        return {
          // por solicitud de KR se cambia puesto_turno por id_h_att2 15/04/2020
          h_lookup_type: 'ID_H_ATT2',
          custom_handler: 'puesto_lleno',
          id_h_lookup_father: this.grupoSeleccionado.value ? this.grupoSeleccionado.value : -1
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/ShiftsManagement/ShiftsManagement.vue